export default __webpack_public_path__ + "static/media/video.d38c47f2.svg";